'use client';

import { useCloudPaymentsPaymentReturnToast } from '@/features/cloudpayments/hooks/useCloudPaymentsPaymentReturnToast';

export const CloudPaymentsPaymentReturnHandler = () => {
  useCloudPaymentsPaymentReturnToast();

  return null;
};
